import baseToString from "./component-library231.mjs";
function toString(value) {
  return value == null ? "" : baseToString(value);
}
export {
  toString as default
};
